/* eslint-disable no-nested-ternary */
/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';
import { Col } from '../../../base/Grid';

export const PhotoCol = styled(Col)`
  ${({ theme }) => {
    const desktop = theme.useMediaQuery(theme.breakpoints.up('small'));
    // was unable to increase the specificity
    return css`
        padding-left: ${desktop ? 0 : '1rem'} !important;
        margin-bottom: ${desktop ? 0 : '1.5rem'};
      `;
  }}
  `;

export const StyledImg = styled.img`
  ${({ theme, photoWidth }) => {
    const tiny = theme.useMediaQuery(theme.breakpoints.down('small'));

    return css`
        width: ${(tiny) ? '100%' : photoWidth ? `${photoWidth}%` : 'auto'};
      `;
  }}
  `;
